import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import Layout from '../../../components/Layout/Layout';
import useFilters from '../../../hooks/useFilters';
import Referrers from '../Referrers/Referrers';
import useGetReportsState from '../useGetReportsState';
import useSx from './sx';

export default function ReferrersReport() {
  const { startDate, endDate } = useGetReportsState();
  const navigate = useNavigate();

  const [filters] = useFilters();
  const sx = useSx();

  const handleNavigation = () => {
    navigate({ pathname: '/' });
  };

  return (
    <Box sx={sx.root}>
      <Layout title="Reportes" hideExport onGoBack={handleNavigation}>
        <Referrers
          startDate={startDate}
          endDate={endDate}
          startDateFormattedParam={filters.start || ''}
          endDateFormattedParam={filters.end || ''}
        />
      </Layout>
    </Box>
  );
}
